import TextInputComponent from './TextInputComponent';
export default TextInputComponent;
